import { GetBlogs_posts_edges, GetBlogs_posts_edges_node } from '@src/types/generated/GetBlogs';
import React, { useEffect, useState } from 'react';
import BlogCard from '../blog-card';
import { EVENT_LOCATION } from '@src/hooks/useTrackEvent';
import { useInView } from 'react-intersection-observer';

export const useBlogs = () => {
    const [lastRowRef, lastRowInView] = useInView();
    const [visibleBlogs, setVisibleBlogs] = useState<GetBlogs_posts_edges[]>([]);
    const [firstBlogs, setFirstBlogs] = useState<GetBlogs_posts_edges_node[]>([]);
    const [finished, setFinished] = useState(false);

    useEffect(() => {
        const fetchBlogs = async () => {
            const response = await fetch(`/api/blog/get-blog-previews`, {
                headers: { 'Content-Type': 'application/json' },
            });

            const result: GetBlogs_posts_edges[] = await response.json();

            setVisibleBlogs(result);
            setFirstBlogs(result.map((x) => x.node));
        };

        void fetchBlogs();
    }, []);

    useEffect(() => {
        const fetchNextBlogs = async () => {
            const lastCursor = visibleBlogs[visibleBlogs.length - 1].cursor;
            const response = await fetch(`/api/blog/get-blog-previews?cursor=${lastCursor}`, {
                headers: { 'Content-Type': 'application/json' },
            });

            const result = await response.json();

            if (result.length < 1) {
                setFinished(true);
            }

            setVisibleBlogs([...visibleBlogs, ...result]);
        };

        lastRowInView && fetchNextBlogs();
    }, [lastRowInView]);

    const renderedBlogs = visibleBlogs.map((blog, i) => {
        const props = { key: blog.cursor };

        if (i === visibleBlogs.length - 5) {
            props['ref'] = lastRowRef;
        }

        return (
            <div {...props}>
                <BlogCard blog={blog.node} location={EVENT_LOCATION.BLOG} />
            </div>
        );
    });

    return {
        firstBlogs,
        loading: lastRowInView && !finished,
        renderedBlogs,
    };
};
